import React from 'react'
import {observer} from 'mobx-react-lite'
import {Table, Typography} from 'antd'
import {useInjection} from 'dna-react-ioc'
import {IDccStore} from '../../IDccStore'
import {DccStoreSymbol} from '../../DCC'
import {getAmountWithCurrency} from '~/code/utils'
import styles from './styles.scss'
import {useTranslation} from 'react-i18next'

export const DccTablePaginationContainerStoreSymbol = Symbol('DccTablePaginationContainerStore')

export const DccTable = observer(() => {
    const {t} = useTranslation()
    const store = useInjection<IDccStore>(DccStoreSymbol)
    const {data, columns, isLoading, totals} = store

    return (
        <Table
            scroll={{x: 1000, y: 500}}
            loading={isLoading}
            columns={columns}
            dataSource={data}
            rowKey='id'
            pagination={false}
            summary={() =>
                totals ? (
                    <Table.Summary fixed='top'>
                        <Table.Summary.Row className={styles.dccTotals}>
                            <Table.Summary.Cell index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell index={1}>
                                <Typography.Text strong={true}>{t('DCC.totals')}</Typography.Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2}></Table.Summary.Cell>
                            <Table.Summary.Cell index={3} align='right'>
                                <Typography.Text strong={true}>
                                    {totals.totalTransactions.toLocaleString()}
                                </Typography.Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={4} align='right'>
                                <Typography.Text strong={true}>
                                    {getAmountWithCurrency(totals.totalAmount)}
                                </Typography.Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={5} align='right'>
                                <Typography.Text strong={true}>
                                    {getAmountWithCurrency(totals.totalRebateAmount)}
                                </Typography.Text>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                    </Table.Summary>
                ) : null
            }
        />
    )
})
